/**
 * What can be done on a link node (a map linked into another; states in
 * docs/architecture/sync.md, "Link states"). Shared by the desktop views,
 * the data layer (node-operations.js) and the mobile app, so they agree.
 */

/**
 * A link that shows no content here (not loaded, or nested, duplicate,
 * conflicting): nothing can be added under it or renamed, since it would be
 * written under the link node in the host map and stay hidden. Moving and
 * deleting the link stay possible.
 * @param {Object} node - composited tree node
 */
export function isInertLink(node) {
  if (!node?.linkedDocId) return false;
  return node._linkedState !== "loaded" || !!(node._nestedReference || node._duplicate || node._idConflict);
}

/**
 * A link inside linked content: it belongs to that map, so it is never
 * moved, unlinked or deleted from here.
 */
export function isNestedLink(node) {
  return !!(node?.linkedDocId && node._nestedReference);
}

/** The linked map has content to show on its own: offer to open it. */
export function canOpenLinkedMap(node) {
  return !!node?.linkedDocId && ["loaded", "nested", "conflict"].includes(node._linkedState);
}

/** No access to the linked map yet, and access can be requested. */
export function canRequestLinkAccess(node) {
  return !!node?.linkedDocId && node._linkedState === "no-access";
}
